import React, { useState, useEffect, useRef, useCallback } from "react";
import Button from "../Button";
import modalClose from "../../img/icons/Close-m-grey.svg";
import modalErrorIcon from "../../img/icons/error-icon-border.svg";
import addToAnalogIcon from "./../../img/icons/addToAnalogIcon.svg";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { getProjects } from "../../actions/myanalog";
import InputDropDown from "./InputDropDown/InputDropDown";
import ToggleButton from "./ToggleButton";
import NewProjectSection from "./NewProjectSection";
import { LoadingIcon } from "../LoadingIcon.js/LoadingIcon";
import {
  addToCustomProject,
  addToMyAnalogProject,
  bookmarkTable,
  createProject,
} from "../../actions/myanalog";
import TableSection from "./TableSection";

let controller = new AbortController();

/**
 * @name AddMyAnalogModal
 * @function
 * @description Displays AddMyAnalogModal for different cases
 * @returns {JSX}
 * @param {*} props
 */
const AddMyAnalogModal = (props) => {
  const dispatch = useDispatch();
  const modalState = useSelector((state) => state.myanalog);
  const { 
    modalMessage, dropDownTitle, dropDownDefaultText, dropDownItems,
  } = modalState ?? {};
  const [addToMyAnalogType, setAddToMyAnalogType] = useState(0);
  const labels = useSelector( ( state ) => state.labels );
  const [loading, setLoading] = useState(true);
  const { button: buttonLabels } = labels;
  const [isSubscription, setIsSubscription] = useState(false);
  // Should be empty at starting, will be updated once the user selects a project
  const [projectID, setProjectID] = useState("");
  const [projectName, setProjectName] = useState("");
  const [newProjTitle, setNewProjTitle] = useState("");
  const [newProjDesc, setNewProjDesc] = useState("");
  const [note, setNote] = useState("");
  const providedTableName = modalState.tableModal;
  const [tableName, setTableName] = useState(providedTableName);
  let currentFocus = null;
  const addMyAnalogModalRef = useRef(null);
  let currentDropdownState = false;
  let errorFocus = null
  /**
   * @name handleConfirm
   * @function
   * @const
   * @description Function to handle Confirm button and store user preference in local storage
   */
  const handleConfirm = () => {
    let tableNameProvided=providedTableName?.replace(/<(.|\n)*?>/g, '');
    switch (addToMyAnalogType) {
      case 1:
        providedTableName
          ? dispatch(
              addToCustomProject({
                productID: tableName ? tableName : tableNameProvided,
                productURL: modalState.productID ? `${modalState.productsURL}/${modalState.productID}` : modalState.productURL,
                projectID: projectID,
                projectName: projectName,
                artifact: 3,
                description: note,
                translationValue: modalState.transalationObject,
              })
            )
          : dispatch(
              addToCustomProject({
                productID: modalState.productID,
                projectName: projectName,
                productURL: modalState.productID ? `${modalState.productsURL}/${modalState.productID}` : modalState.productURL,
                projectID: projectID,
                artifact: 0,
                translationValue: modalState.transalationObject,
              })
            );
        return;
      case 2:
        dispatch(
          providedTableName
            ? createProject({
                productURL: modalState.productID ? `${modalState.productsURL}/${modalState.productID}` : modalState.productURL,
                projectTitle: newProjTitle,
                projectDescription: newProjDesc,
                providedTableName: tableName
                  ? tableName
                  : tableNameProvided,
                tableDesc: note,
                translationValue: modalState.transalationObject,
              })
            : createProject({
                productID: modalState.productID,
                productURL: modalState.productID ? `${modalState.productsURL}/${modalState.productID}` : modalState.productURL,
                projectTitle: newProjTitle,
                projectDescription: newProjDesc,
                translationValue: modalState.transalationObject,
              })
        );
        return;
      case 0:
        providedTableName
          ? dispatch(
              bookmarkTable({
                tableTitle: tableName ? tableName : tableNameProvided,
                pageURL: modalState.productID ? `${modalState.productsURL}/${modalState.productID}` : modalState.productURL,
                tableNote: tableName ? tableName : note,
                translationValue: modalState.transalationObject,
                errorAreaName: dropDownDefaultText
              })
            )
          : dispatch(
              addToMyAnalogProject({
                productID: modalState.productID,
                subscription: isSubscription,
                projectName: projectName,
                translationValue: modalState.transalationObject,
                errorAreaName: dropDownDefaultText
              })
            );
        return;
    }
  };

  /**
   * @name handleCancel
   * @function
   * @const
   * @description Function to handle cancel button in alert modal
   */
  const handleCancel  = useCallback(() => {
    setAddToMyAnalogType(0);
    setProjectID("");
    setNote("");
    setTableName("");
    setNewProjTitle("");
    setNewProjDesc("");
    setIsSubscription(false);
    modalState.onCancel();
  }, [modalState.onCancel]);

  /**
   * @name handleExit
   * @function
   * @const
   * @description Function to handle exit button in alert modal
   */
   const handleExit  = (event) => {
    if(event.key ==="Enter"){
      handleCancel();
    }
    };

    /**
   * @name handleUserNavigation
   * @function
   * @const
   * @description Function to handle key pressed by user
   */
     const handleUserNavigation = useCallback((event) => {
      const modalElement = addMyAnalogModalRef.current;
      const focusableElements = Array.from(modalElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.key === "Tab") {
        //If "Tab + Shift"
        if (event.shiftKey) {
          //If it's in the first element inside the modal, goes back to the last
          if (document.activeElement === firstElement) {
              lastElement.focus();
              event.preventDefault();
          }
        }
        //If "Tab"
        else {
              //If focus is on last element, then returns to the first
              if (document.activeElement === lastElement) {
                firstElement.focus();
                event.preventDefault();
              }
          }
        currentFocus = document.activeElement;
  
      }
      if (event.key === "Escape" && !currentDropdownState) {
        handleCancel();
        event.preventDefault();
      }
      if(addMyAnalogModalRef.current){
        currentDropdownState = addMyAnalogModalRef.current.getElementsByClassName("dropdown-header__myAnalog__input")[0].classList.contains("open");
      }
    }, [modalState.onCancel]);


  // Initialize focus when the modal opens and clean up event listeners when it closes
  useEffect(() => {
    if (modalState.isOpen) {
      //Selecting the "close" icon so the focus shifts to that when modal is open
      currentFocus = addMyAnalogModalRef.current.getElementsByClassName("header__close");
      currentFocus[0].focus();
      
      document.addEventListener("keydown", handleUserNavigation);

      if (modalState.modalError) {
        errorFocus = addMyAnalogModalRef.current.getElementsByClassName("new-project-container-name-input");
        if(errorFocus[0]) {
          errorFocus[0].focus();
        }
      }
      return () => {
        document.removeEventListener("keydown", handleUserNavigation);
        //Selecting the "Add my Analog" icon so the focus shifts to that when modal is closed
        let addMyAnalogButton = document.getElementsByClassName("add-my-analog-btn");
        addMyAnalogButton[0].focus();
      };

    } 
  }, [modalState.isOpen, handleUserNavigation, modalState.modalError]);

  // Fetch projects when the modal opens and reset loading state when it closes
  useEffect( () => {
    if ( modalState.isOpen ) {
      dispatch(
        getProjects( {
          translationValue: modalState.translationValue,
          settledCallback: () => setLoading( false ),
          signal: controller.signal,
        } )
      );
    } else {
      if ( controller && !controller.signal?.aborted ) {
        // Abort any ongoing request and reset controller
        controller.abort?.();
        controller = new AbortController();
      }
      setLoading( true );
    }
  }, [ modalState.isOpen ] );

  return !modalState.isOpen ? (
    <></>
  ) : (
    <div
      className={`modal-overlay ${props.mobile ? "modal-overlay-mobile" : ""}`}
    >
      <div
        className={`modal-content ${props.mobile ? "modal-content-mobile-add-to-myanalog" : ""}`}
        ref={addMyAnalogModalRef} 
        role="alertdialog" 
        aria-modal="true" 
        aria-labelledby={ buttonLabels.addToMyAnalog } 
        aria-describedby={ modalMessage }
      >
        <div
          className={`modal-content__header ${
            props.mobile ? "modal-content__header-mobile" : ""
          }`}
        >
          <div className="header__content">
            <img
              className="modal-content__modalIcon"
              src={addToAnalogIcon}
              alt="Hide Columns"
            />
            <div className="header__content__title">
              { buttonLabels.addToMyAnalog }
            </div>
          </div>
          <img
            src={modalClose}
            alt="close"
            className="header__close"
            onClick={handleCancel}
            onKeyPress = {handleExit}
            tabIndex={0}
          />
        </div>
        {!loading && modalState.modalError ? (
          <div className="error__content" role="alert" aria-live="assertive" aria-atomic="true">
            <img
              className="modal-content__error_icon"
              src={modalErrorIcon}
              alt="Error-Icon"
            />
            <span className="modal-content__message__error">
              {modalState.modalError.toString()}
            </span>
          </div>
        ) : (
          <></>
        )}

        <div className={ `modal-content__message${loading ? ' modal-content__message--loading' : ''}` }>
          {
            loading
              ? (
                <div className="loading-icon-container">
                  <LoadingIcon width="60" height="60" />
                </div>
              )
              : null
          }

          <div className="modal-content__message__title">
            { modalMessage ?? "" }
          </div>
          {!modalState.haveDropDown ? (
            <></>
          ) : (
            <div className="dropdown-container">
              <span className="dropdown-container-title body-small">
                { dropDownTitle }
              </span>
              <InputDropDown
                mobile={props.mobile}
                tabIndex={0}
                options={dropDownItems}
                title={dropDownTitle}
                dropDownDefaultText={dropDownDefaultText}
                newProjectText={labels.myAnalogNewProject}
                setAddToMyAnalogType={(type) => setAddToMyAnalogType(type)}
                setProjectID={(e) => {
                  setProjectID(e);
                }}
                setProjectName={(e) => {
                  setProjectName(e);
                }}
              />
            </div>
          )}
          {!(addToMyAnalogType === 0) ? (
            <></>
          ) : providedTableName ? (
            <></>
          ) : (
            <ToggleButton
              state={isSubscription}
              toggleState={(localState) => {
                setIsSubscription(localState);
                console.log(localState);
              }}
              toggleButtonDescription={ labels.receivePcnPdnNotifications }
            />
          )}
          {!(addToMyAnalogType === 2) ? (
            <></>
          ) : (
            <>
              <NewProjectSection
                // This will be made dynamic based on props in the future, as it will be utilized in various scenarios.
                newProjectTitle={ labels.createNewProject }
                newProjectNameText={ labels.projectName }
                setNewProjTitle={setNewProjTitle}
                setNewProjDesc={setNewProjDesc}
                options={dropDownItems}
                projectNameErrorText={ labels.projectNameTakenError }
                newProjectDescriptionText={ labels.projectDescription }
              />
            </>
          )}
          {providedTableName ? (
            <TableSection
              providedTableName={providedTableName.replace(/<(.|\n)*?>/g, '')}
              setTableName={setTableName}
              tabIndex={0}
              setNote={setNote}
            />
          ) : (
            <></>
          )}
        </div>

        {!modalState.haveActions ? (
          <></>
        ) : (
          <div
            className={`modal-content__buttons ${
              props.mobile ? "modal-content__buttons-mobile" : ""
            }`}
          >
            <div></div>
            <div
              className={`modal-content__action-buttons ${
                props.mobile ? "modal-content__action-buttons-mobile" : ""
              } `}
            >
              <Button
                className={`secondary_btn ${props.mobile ? "cancel-btn" : ""}`}
                onClick={handleCancel}
                value={ buttonLabels.cancel }
                tabIndex={0}
                onKeyPress={handleExit}
              />
              <Button
                disabled={loading}
                className={`primary_btn ${props.mobile ? "confirm-btn" : ""}`}
                onClick={handleConfirm}
                tabIndex={0}
                value={ buttonLabels.confirm }
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddMyAnalogModal;
